import { render, staticRenderFns } from "./DashboardInsights.vue?vue&type=template&id=ea4b8b28&scoped=true"
import script from "./DashboardInsights.vue?vue&type=script&lang=js"
export * from "./DashboardInsights.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea4b8b28",
  null
  
)

export default component.exports